import classNames from 'classnames';
import React from 'react';

import { Typography } from '@sravni/react-design-system';

import { ViewsIcon } from '../Icons/ViewsIcon';

import styles from './styles.module.scss';

interface Props {
  children: number;
  className?: string;
  size?: React.ComponentProps<typeof Typography.Text>['size'];
}
export const Views = ({ children, className, size = 14 }: Props) => {
  return (
    <div className={classNames(styles.views, className)}>
      <ViewsIcon className={styles.viewsIcon} />
      <Typography.Text size={size}>{children?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}</Typography.Text>
    </div>
  );
};
